import React from "react";
import OrderForm from "./OrderForm";
import CancelForm from "./CancelForm";
import { ErrorBoundary } from "react-error-boundary";

import Modal from "react-bootstrap/Modal";

class OrderModal extends React.Component {
  constructor(props) {
    super(props);
    this.title = this.title.bind(this);
  }

  title() {
    if (this.props.mode === 'edit') {
      return 'Edit Order';
    } else if (this.props.mode === 'cancel') {
      return 'Cancel Order';
    } else {
      return 'Create New Order';
    }
  }



  render() {
    const title  = () => {
      if (this.props.mode === 'edit'){
          return 'Edit Order';
        } else if (this.props.mode === 'cancel'){
          return 'Are you sure?';
        } else {
          return 'Create New Order';
        }
    }

    function Fallback({ error, resetErrorBoundary }) {
      // Call resetErrorBoundary() to reset the error boundary and retry the render.
    
      return (
        <div role="alert">
          <p>Something went wrong:</p>
          <pre style={{ color: "red" }}>{error.message}</pre>
        </div>
      );
    }
    
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton closeVariant={"white"}>
          <Modal.Title id="contained-modal-title-vcenter">
            {title()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ErrorBoundary FallbackComponent={Fallback}>
            {this.props.mode === "cancel" ? (
              <CancelForm
                order={this.props.order}
                mode={this.props.mode}
                onHide={this.props.onHide}
                userFullName={this.props.userFullName}
              />
            ) : (
              <OrderForm
                order={this.props.order}
                mode={this.props.mode}
                onHide={this.props.onHide}
                userFullName={this.props.userFullName}
                deliveryPointDefault={this.props.deliveryPointDefault}
                carrierPref={this.props.carrierPref}
                peopleOnsite={this.props.peopleOnsite}
              />
            )}
          </ErrorBoundary>
        </Modal.Body>
        {/* <Modal.Footer>
          <button onClick={this.props.onHide}>Close</button>
        </Modal.Footer> */}
      </Modal>
    );
  }
}

export default OrderModal;